import { Helmet } from "react-helmet-async";

import HeroSection from "../components/HeroSection";
import OurServices from "../components/OurServices";
import PopularTests from "../components/PopularTests";
import HealthPackages from "../components/HealthPackages";
import WhyChoose from "../components/WhyChoose";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>
          TanBio BioMed Genomics Laboratory | Diagnostic Centre in Thiruvarur
        </title>

        <meta
          name="description"
          content="TanBio BioMed Genomics Laboratory provides pathology, microbiology, biochemistry, molecular diagnostics, genomics, preventive health checkups and laboratory testing in Thiruvarur."
        />

        <link rel="canonical" href="https://tanbiomedlab.com/" />
      </Helmet>

      <section id="home">
        <HeroSection />
      </section>

      <section id="services">
        <OurServices />
      </section>

      <section id="popular-tests">
        <PopularTests />
      </section>

      <section id="packages">
        <HealthPackages />
      </section>

      <section id="why-choose">
        <WhyChoose />
      </section>
    </>
  );
}